import React from 'react';
import { useTranslation } from 'react-i18next';
import { Globe } from 'lucide-react';

const LanguageSwitcher = () => {
  const { i18n, t } = useTranslation();

  const languages = [
    { code: 'en', label: 'English', flag: '🇬🇧' },
    { code: 'uk', label: 'Українська', flag: '🇺🇦' }
  ];

  const currentLanguage = languages.find(lang => lang.code === i18n.language) || languages[0];

  const handleLanguageChange = (langCode) => {
    i18n.changeLanguage(langCode);
    localStorage.setItem('i18nextLng', langCode);
  };

  return (
    <div className="relative group">
      <button
        className="flex items-center gap-2 px-4 py-2 rounded-lg bg-white/70 hover:bg-white/90 border border-neutral-200 transition-all duration-200 shadow-sm hover:shadow-md"
        title={t('language.select')}
      >
        <Globe className="h-5 w-5 text-primary-600" />
        <span className="text-sm font-medium text-neutral-700">
          {currentLanguage.flag} {currentLanguage.label}
        </span>
      </button>

      {/* Dropdown menu */}
      <div className="absolute right-0 mt-2 w-48 rounded-lg bg-white shadow-lg border border-neutral-200 opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200 z-50">
        {languages.map((language) => (
          <button
            key={language.code}
            onClick={() => handleLanguageChange(language.code)}
            className={`w-full flex items-center gap-3 px-4 py-3 text-left text-sm hover:bg-primary-50 transition-colors duration-200 first:rounded-t-lg last:rounded-b-lg ${
              i18n.language === language.code
                ? 'bg-primary-50 text-primary-700 font-semibold'
                : 'text-neutral-700'
            }`}
          >
            <span className="text-xl">{language.flag}</span>
            <span>{language.label}</span>
            {i18n.language === language.code && (
              <span className="ml-auto text-primary-600">✓</span>
            )}
          </button>
        ))}
      </div>
    </div>
  );
};

export default LanguageSwitcher;
